import useSWR from 'swr';

import { Contest } from '@/api/contests/types';
import { fetchApiClient, fetchApiClientDestructData } from '@/api/fetchers/fetchApiClient';

export const useOngoingContests = () => {
  const {
    data: contests,
    isLoading: contestsAreLoading,
    error: competitionsError,
  } = useSWR<Contest[] | null>(`/v2/competitions`, fetchApiClientDestructData);

  const {
    data: timestamp,
    isLoading: timestampIsLoading,
    error: timeError,
  } = useSWR<{ lts: number } | null>(`/v2/time`, fetchApiClient);

  const mappedContests =
    !timestamp || !contests || timeError || competitionsError
      ? null
      : (contests || []).map((c) => ({
          ...c,
          closeAt: c.closeAt * 1000,
          startAt: c.startAt * 1000,
        }));

  return {
    cards: mappedContests,
    isLoading: contestsAreLoading || timestampIsLoading,
  };
};
